import { TextField } from '@mui/material';
import React from 'react';
 
export default function DateField({ value, field, onChange }) {
  return (
    <TextField type="date" value={value} onChange={(e) => onChange(e.target.value)} />
  )
}